var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2506 5.47299V11.1236H1.28133V2.15435H9.27037L10.6798 0.873047H0V12.405H11.5319V4.29418L10.2506 5.47299Z",
    fill: "white",
    fillOpacity: 0.69
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5376 0.405029L5.58644 6.72196L3.40817 4.55012L2.5625 5.39579L5.6441 8.47737L13.4538 1.30197L12.5376 0.405029Z",
    fill: "white",
    fillOpacity: 0.69
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerCheck);
export default __webpack_public_path__ + "static/media/banner_check.dd79335f3c5dc0359c07fb6336dd4a1b.svg";
export { ForwardRef as ReactComponent };